var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009295"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask Copy",
    width: 15,
    height: 15,
    fill: "#128C4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 455",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98828 9.29624H9.53467V8.0091L10.353 8.43815V9.29624H11.9896V11.0124H9.53467V10.1543H3.80658L2.98828 9.29624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 456",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98828 6.71618L3.39743 6.28714L2.98828 5.85809V5H3.80658V5.85809L4.21573 5H5.44318V5.42905H4.62488V5.85809H5.44318V7.57428H4.62488V6.71618H5.03403V6.28714H4.21573V7.57428H3.80658V6.71618H3.39743V7.57428H2.98828V6.71618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 456_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53418 6.71618L9.94333 6.28714L9.53418 5.85809V5H10.3525V5.85809L10.7616 5H11.9891V5.42905H11.1708V5.85809H11.9891V7.57428H11.1708V6.71618H11.5799V6.28714H10.7616V7.57428H10.3525V6.71618H9.94333V7.57428H9.53418V6.71618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 456_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71564 5.64156C8.71564 5.76115 8.65171 5.92513 8.56793 6.01299L8.4542 6.13224C8.37262 6.21779 8.37042 6.35418 8.4542 6.44203L8.56793 6.56129C8.64951 6.64683 8.71564 6.80801 8.71564 6.93272V7.35774C8.71564 7.47733 8.62807 7.57428 8.50915 7.57428H8.10383C7.98979 7.57428 7.89734 7.48244 7.89734 7.35774V6.93272C7.89734 6.81313 7.85958 6.79537 7.80244 6.9152L7.58309 7.37525C7.53068 7.48517 7.39187 7.57428 7.2855 7.57428H6.46343C6.35149 7.57428 6.26074 7.47476 6.26074 7.35975C6.26074 7.24127 6.34831 7.14523 6.46723 7.14523H6.87255C6.98659 7.14523 7.07904 7.04572 7.07904 6.93071C7.07904 6.81223 6.99147 6.71618 6.87255 6.71618H6.46723C6.35319 6.71618 6.26074 6.62391 6.26074 6.50575V5.21044C6.26074 5.09422 6.34831 5 6.46723 5H6.87255C6.98659 5 7.07904 5.09183 7.07904 5.21653V5.64156C7.07904 5.76115 6.98415 5.85809 6.87447 5.85809C6.76148 5.85809 6.66989 5.9576 6.66989 6.07261C6.66989 6.19109 6.75746 6.28714 6.87638 6.28714H7.2817C7.39574 6.28714 7.48819 6.18614 7.48819 6.07459V5.21254C7.48819 5.09516 7.58309 5 7.69277 5C7.80575 5 7.89734 5.09183 7.89734 5.21653V5.64156C7.89734 5.76115 7.99224 5.85809 8.10191 5.85809C8.2149 5.85809 8.30649 5.76626 8.30649 5.64156V5.21653C8.30649 5.09695 8.40138 5 8.51106 5C8.62405 5 8.71564 5.09183 8.71564 5.21653V5.64156Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/SA.d63a52c6f920161135300001636dfd52.svg";
export { ForwardRef as ReactComponent };